<template>
    <div class="form-content" :ref="stepName" style="position:relative">
        <div class="form-header">
            <p><span>J’autorise Testachats à encaisser, par le débit de mon compte bancaire, les 2&nbsp;€ de ma période d’essai. À l’issue de cette période d’essai de 2 mois, mon abonnement sera
                automatiquement reconduit et je profiterai d’une réduction de 50 % pour le reste de ma première année. Je ne paierai donc que 12,33&nbsp;€ par mois au lieu de 24,66&nbsp;€. Et ce,
                jusqu’à la révocation expresse de mon affiliation. </span></p>
        </div>
        <PaymentOptinForm></PaymentOptinForm>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>

        <p class="paytrust-text">Vous restez libre d'interrompre votre abonnement à tout moment.</p>
        <img class="paytrust-img" src="/images/fr_multigift/pay-trust.png" alt="Universal SSL">
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import {Button} from "../../../../../../models/fields/Button";
import PaymentOptinForm from "./PaymentOptinForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: {PaymentOptinForm},
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
